import { createAsyncActionWithMeta } from "../../../../../libraries/packages/redux-utils/src/request/action";
import api from "../storeApi";

export const placelistsGetAction = createAsyncActionWithMeta(
  "placelists_placelistsGetAction_REQUEST",
  "placelists_placelistsGetAction_SUCCESS",
  "placelists_placelistsGetAction_FAILURE"
)<Parameters<typeof api.placelists.methods.get>, any, Error>();
